
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/service/app.service';
import { UserService } from 'src/app/service/user-service.service';
import { endpoints } from 'src/endpoint/endpoints';
import { saveAs } from 'file-saver';

import { PazientiService } from 'src/app/main/pazienti/service/pazienti.service';
import { TokenService } from '../service/token.service';

@Component({
  selector: 'app-report-paziente',
  templateUrl: './report-paziente.component.html',
  styleUrls: ['./report-paziente.component.scss']
})
export class ReportPazienteComponent implements OnInit {

  layoutEnabled = 'layout7';
  patientId;

  datePipe = new DatePipe('en-US');
  token;

  flagFU = false;
  flagUV = false;

  json_generale = {
    dettagli_paziente: [
      { label: 'Identificativo', value: '' },
      { label: 'Genere', value: '' },
      { label: "Età", value: '' },
      { label: 'Categoria paziente', value: '' },
      { label: 'Data accettazione consenso informato', value: '' }
    ],
    sintomi_visita: [
      { label: 'Mal di testa', value: '' },
      { label: 'Fatica', value: '' },
      { label: 'Vertigini/capogiro', value: '' },
      { label: 'Affanno', value: '' },
      { label: 'Gonfiore alle gambe', value: '' }
    ],
    parametri_visita: [
      { label: 'Frequenza cardiaca', value: '' },
      { label: 'FE (%)', value: '' },
      { label: 'Sistolica (mmHg)', value: '' },
      { label: 'Diastolica (mmHg)', value: '' },
      { label: 'Frequenza respiratoria', value: '' },
      { label: "Saturazione dell'ossigeno (%)", value: '' }
    ],
    laboratorio_visita: [
      { label: 'Glicemia (mg/L)', value: '' },
      { label: 'HbA1c (mmol/mol)', value: '' },
      { label: 'Creatina (mg/dL)', value: '' },
      { label: 'Ldl (mmol/mol)', value: '' },
      { label: 'Hdl (mg/dL)', value: '' },
      { label: 'Trigliceridi (mg/dL)', value: '' },
      { label: 'Colesterolo totale (mg/dL)', value: '' }
    ],
    farmaci: ''
  };

  constructor(
    private http: HttpClient,
    private userService: UserService,
    private router: Router,
    private pazientiService: PazientiService,
    private appSrv: AppService,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private tokenService: TokenService
  ) { }

  ngOnInit() {
    this.pazientiService.resetPatient();

    this.route.queryParamMap.subscribe((params) => {
      const id = params.get("id");
      const token = params.get("token");


      if (!id || !token) {
        if (!id) console.error("id utente non passato.");
        if (!token) console.error("token non passato.");
        return;
      }

      this.patientId = id;
      this.token = token;
      this.tokenService.saveToken({ access_token: this.token });

      this.http.get(endpoints.me).subscribe({
        next: (resp: any) => {
          if (resp) {
            this.userService.saveUser(resp);


            this.loadPatientData(this.patientId);

          }
        },
        error: (err) => {
          console.error("Errore nel recupero dell'utente", err);
          this.router.navigate(['/login']);
          this.tokenService.deleteToken();
          this.toastr.error("Errore nella retrive dell'utente.");
        }
      });
    });
  }




  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  async getClinicalImpressionListById() {
    try {
      const resp: any = await this.http.get(
        endpoints.getAllClinicalImpressionByPatientId + '?patientId=' + this.patientId
      ).toPromise();


      let entry: any[] = [];
      if (resp?.message?.entry) {
        entry = resp.message.entry;
      } else if (Array.isArray(resp?.message)) {
        entry = resp.message;
      } else if (Array.isArray(resp?.entry)) {
        entry = resp.entry;
      } else if (Array.isArray(resp)) {
        entry = resp;
      }


      if (!entry || entry.length === 0) {
        console.warn("Nessuna ClinicalImpression trovata per il paziente");
        return;
      }

      this.cdr.detectChanges();


      const pvId = entry.find((e: any) =>
        e.resource?.description?.toLowerCase().includes("prima")
      )?.resource?.id ?? null;

      const fuId = entry.find((e: any) =>
        e.resource?.description?.toLowerCase().includes("follow")
      )?.resource?.id ?? null;

      const uvId = entry.find((e: any) =>
        e.resource?.description?.toLowerCase().includes("ultima")
      )?.resource?.id ?? null;

      this.flagFU = !!fuId;
      this.flagUV = !!uvId;


      if (!pvId) {
        this.toastr.error("Dati della prima visita mancanti.");
        return;
      }

      this.loadSintomiVisita(pvId, fuId, uvId);
      this.loadParametriVisita(pvId, fuId, uvId);
      this.loadParametriLabo(pvId, fuId, uvId);
      this.loadFarmaci();

    } catch (err) {
      console.error("Errore getClinicalImpressionListById", err);
    }
  }


  splitValue(value: string | undefined | null): string[] {
    if (!value) {
      return ["NC", this.flagFU ? "NC" : "", this.flagUV ? "NC" : ""];
    }
    return value.split('->').map(v => v.trim() || "NC");
  }

  formatValue(label: string, val: string | undefined | null): string {
    if (!val || val === "0") return "NC";

    const unit = this.getUnit(label);
    let cleaned = val;

    if (cleaned.endsWith('.0')) {
      cleaned = cleaned.slice(0, -2);
    }

    const numericValue = cleaned.toString().replace(',', '.');
    if (!isNaN(numericValue as any)) {
      const num = parseFloat(numericValue);
      cleaned = Number(num.toFixed(2)).toString(); // max 2 decimali
    }

    return unit ? `${cleaned}` : cleaned;
  }

  getHighlightClass(grade: string): string {
    switch (grade) {
      case 'G0': return 'highlight-gray';
      case 'G1': return 'highlight-normal';
      case 'G2': return 'highlight-warning';
      case 'G3':
      case 'G4': return 'highlight-alert';
      case 'NC': return 'highlight-gray';
      default: return '';
    }
  }

  units: { [key: string]: string } = {
    'Frequenza cardiaca': 'bpm',
    'FE (%)': '%',
    'Sistolica (mmHg)': 'mmHg',
    'Diastolica (mmHg)': 'mmHg',
    'Frequenza respiratoria': 'atti/min',
    "Saturazione dell'ossigeno (%)": '%',
    "Creatina (mg/dL)": 'mg/dL',
    "HbA1c (mmol/mol)": 'mmol/mol',
    "Glicemia (mg/L)": 'mg/L'
  };

  getUnit(label: string): string {
    return this.units[label] ?? '';
  }

  loadPatientData(patientId: string) {
    this.http.get(endpoints.getPatientByPatientId + patientId).toPromise().then((resp: any) => {
      if (resp && resp.message) {
        const patient = resp.message;
        let identificativo = '';
        if (patient.name) {
          const usualName = patient.name.find((n: any) => n.use === 'usual');
          if (usualName?.given?.length > 0) {
            identificativo = usualName.given[0];
          }
        }
        let genere = '';
        switch (patient.gender) {
          case 'male': genere = 'M'; break;
          case 'female': genere = 'F'; break;
          case 'other': genere = 'A'; break;
          case 'unknown': genere = 'S'; break;
          default: genere = ''; break;
        }
        let eta = '';
        let categoria = '';
        let dataConsenso = '';
        if (patient.extension) {
          patient.extension.forEach((ext: any) => {
            if (ext.url === "http://hl7.org/fhir/SearchParameter/patient-extensions-Patient-age") {
              eta = ext.valueInteger;
            }
            if (ext.url === "http://riatlas.it/extensions#diabetesCategory") {
              categoria = ext.valueString;
            }
            if (ext.url === "http://riatlas.it/extensions#informedconsentacceptance") {
              dataConsenso = this.datePipe.transform(new Date(ext.valueDateTime), 'dd/MM/yyyy');
            }
          });
        }
        this.json_generale.dettagli_paziente = [
          { label: 'Identificativo', value: identificativo },
          { label: 'Genere', value: genere },
          { label: "Età", value: eta },
          { label: 'Categoria paziente', value: categoria },
          { label: 'Data accettazione consenso informato', value: dataConsenso }
        ];
      }
    }).catch(err => console.error("Errore nel caricamento dati paziente", err));
    this.getClinicalImpressionListById();
  }
  getVisitInformation() {
    this.getClinicalImpressionListById();
  }

  async loadSintomiVisita(pvId: string, fuId?: string, uvId?: string) {
    try {
      const respPV: any = await this.http.get(endpoints.getAdverseEvent + pvId).toPromise();

      let respFU: any = null;
      let respUV: any = null;

      if (fuId) {
        respFU = await this.http.get(endpoints.getAdverseEvent + fuId).toPromise();
      }
      if (uvId) {
        respUV = await this.http.get(endpoints.getAdverseEvent + uvId).toPromise();
      }

      const mapObservation = (obsList: any[] | null) => {
        const map: { [label: string]: string } = {};
        if (!obsList) return map;
        obsList.forEach(o => {
          const code = o.code?.coding?.[0]?.code;
          const label = this.mapSymptomCodeToLabel(code);
          const grado = o.valueString || "NC";
          map[label] = grado;
        });
        return map;
      };

      const mapPV = mapObservation(respPV || []);
      const mapFU = mapObservation(respFU || []);
      const mapUV = mapObservation(respUV || []);

      this.json_generale.sintomi_visita = this.json_generale.sintomi_visita.map(s => {
        const valPV = mapPV[s.label] ?? "NC";
        const valFU = this.flagFU ? (mapFU[s.label] ?? "NC") : "";
        const valUV = this.flagUV ? (mapUV[s.label] ?? "NC") : "";
        return { ...s, value: `${valPV} -> ${valFU} -> ${valUV}` };
      });

    } catch (err) {
      console.error("Errore loadSintomiVisita", err);
      this.toastr.error("Errore nel caricamento dei sintomi.");
    }
  }

  private mapSymptomCodeToLabel(code: string): string {
    switch (code) {
      case "capogiro":
        return "Fatica";
      case "vertigini":
        return "Vertigini/capogiro";
      case "gambe":
        return "Gonfiore alle gambe";
      case "malditesta":
        return "Mal di testa";
      case "affanno":
        return "Affanno";
      default:
        return code;
    }
  }

  async loadParametriVisita(pvId: string, fuId: string, uvId: string) {
    try {
      const [
        respPVvital, respFUvital, respUVvital,
        respPVeco, respFUeco, respUVeco,
        respPVbio, respFUbio, respUVbio
      ]: any[] = await Promise.all([
        this.http.get(endpoints.getVitalSignsByClinicalImpressionId + pvId).toPromise(),
        this.http.get(endpoints.getVitalSignsByClinicalImpressionId + fuId).toPromise(),
        this.http.get(endpoints.getVitalSignsByClinicalImpressionId + uvId).toPromise(),

        this.http.get(endpoints.getEcoexams + pvId).toPromise(),
        this.http.get(endpoints.getEcoexams + fuId).toPromise(),
        this.http.get(endpoints.getEcoexams + uvId).toPromise(),

        this.http.get(endpoints.getBiomarkers + pvId).toPromise(),
        this.http.get(endpoints.getBiomarkers + fuId).toPromise(),
        this.http.get(endpoints.getBiomarkers + uvId).toPromise()
      ]);

      const obsPV = [
        ...(respPVvital?.message || []),
        ...(respPVeco?.message || []),
        ...(respPVbio?.message || [])
      ];
      const obsFU = [
        ...(respFUvital?.message || []),
        ...(respFUeco?.message || []),
        ...(respFUbio?.message || [])
      ];
      const obsUV = [
        ...(respUVvital?.message || []),
        ...(respUVeco?.message || []),
        ...(respUVbio?.message || [])
      ];

      const mapPV = this.mapVitalObservation(obsPV);
      const mapFU = this.mapVitalObservation(obsFU);
      const mapUV = this.mapVitalObservation(obsUV);

      this.json_generale.parametri_visita = this.json_generale.parametri_visita.map(p => {
        const valPV = mapPV[p.label] ?? "0";
        const valFU = mapFU[p.label] ?? "0";
        const valUV = mapUV[p.label] ?? "0";
        return { ...p, value: `${valPV} -> ${valFU} -> ${valUV}` };
      });



    } catch (err) {
      console.error("Errore loadParametriVisita", err);
      this.toastr.error("Errore nel caricamento dei parametri vitali/laboratorio.");
    }
  }


  private mapVitalObservation(obsList: any): { [label: string]: string } {
    const map: { [label: string]: string } = {};

    if (!obsList) return map;

    const list = Array.isArray(obsList)
      ? obsList
      : (obsList.entry ? obsList.entry.map((e: any) => e.resource) : []);

    list.forEach(o => {
      const code = o.code?.coding?.[0]?.code;
      const label = this.mapVitalCodeToLabel(code);
      if (!label) return;

      let value = "";
      if (o.valueQuantity?.value !== undefined) {
        value = o.valueQuantity.value.toString();
      } else if (o.valueString !== undefined) {
        value = o.valueString.toString();
      } else {
        value = "NC";
      }

      map[label] = value;
    });

    return map;
  }



  private mapVitalCodeToLabel(code: string, category?: string): string | null {
    switch (code) {
      case "76282-3":
        return "Frequenza cardiaca";
      case "10230-1":
        return "FE (%)";
      case "8480-6":
        return "Sistolica (mmHg)";
      case "8462-4":
        return "Diastolica (mmHg)";
      case "9279-1":
        return "Frequenza respiratoria";
      case "59408-5":
        return "Saturazione dell'ossigeno (%)";
      case "2345-7": return "Glicemia (mg/L)";
      case "4548-4": return "HbA1c (mmol/mol)";
      case "2157-6": return "Creatina (mg/dL)";
      case "2089-1": return "Ldl (mmol/mol)";
      case "2085-9": return "Hdl (mg/dL)";
      case "2571-8": return "Trigliceridi (mg/dL)";
      case "2093-3": return "Colesterolo totale (mg/dL)";

      default:
        return null; // ignoro tutti gli altri (altezza, peso, BMI, ecc.)
    }
  }

  async loadParametriLabo(pvId: string, fuId: string, uvId: string) {
    try {
      const [respPV, respFU, respUV]: any[] = await Promise.all([
        this.http.get(endpoints.getLaboratoryExams + pvId).toPromise(),
        this.http.get(endpoints.getLaboratoryExams + fuId).toPromise(),
        this.http.get(endpoints.getLaboratoryExams + uvId).toPromise()
      ]);

      const mapPV = this.mapVitalObservation(respPV?.message || []);
      const mapFU = this.mapVitalObservation(respFU?.message || []);
      const mapUV = this.mapVitalObservation(respUV?.message || []);

      this.json_generale.laboratorio_visita = this.json_generale.laboratorio_visita.map(l => {
        const valPV = mapPV[l.label] ?? "0";
        const valFU = mapFU[l.label] ?? "0";
        const valUV = mapUV[l.label] ?? "0";
        return { ...l, value: `${valPV} -> ${valFU} -> ${valUV}` };
      });

    } catch (err) {
      console.error("Errore loadParametriLabo", err);
      this.toastr.error("Errore nel caricamento degli esami di laboratorio.");
    }
  }

  async loadFarmaci() {
    try {
      const resp: any = await this.http.get(endpoints.getTerapieFarmacologicheByPatientId + this.patientId).toPromise();

      if (resp?.entry && resp.total > 0) {
        // estraggo i nomi dai CodeableConcept
        const farmaciList = resp.entry
          .map((e: any) => e.resource?.medicationCodeableConcept?.text)
          .filter((nome: string) => !!nome) // tolgo null/undefined
          .map((nome: string) => `${nome}, attivo`); // puoi aggiungere "attivo" o altro stato qui

        // unisco in stringa unica separata da ";"
        this.json_generale.farmaci = farmaciList.join(";");
      } else {
        this.json_generale.farmaci = ""; // nessun farmaco trovato
      }


    } catch (err: any) {
      console.error("Errore loadFarmaci", err);
      if (err.status === 403) {
        this.toastr.error("Non si dispone dei permessi necessari per eseguire questa operazione.");
        return;
      }
      this.toastr.error("Errore nel caricamento delle terapie farmacologiche.", "ERRORE");
    }
  }

  getFaceIcon(grade: string): string {
    switch (grade) {
      case 'G0': return 'assets/img/IconaG0.png';
      case 'G1': return 'assets/img/IconaG1.png';
      case 'G2': return 'assets/img/IconaG2.png';
      case 'G3': return 'assets/img/IconaG3.png';
      default: return 'assets/img/IconaG0.png';
    }
  }




}
